import { render } from "./CreateNewAppVersionModal.vue?vue&type=template&id=cdddaf8a&scoped=true"
import script from "./CreateNewAppVersionModal.vue?vue&type=script&lang=js"
export * from "./CreateNewAppVersionModal.vue?vue&type=script&lang=js"

import "./CreateNewAppVersionModal.vue?vue&type=style&index=0&id=cdddaf8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdddaf8a"]])

export default __exports__